import { List, GroupCreate, LedgerEdit, Ledger, LedgerCreate, CostCenter, EditCostCenter, GroupEdit, LedgerBarcode, LedgerView, CostCenterCreate } from "../Components/index.js";

export default [
    {
        path: "/account/group",
        component: List,
        name: "account.group",

        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/group/create",
        component: GroupCreate,
        name: "account.group.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/group/:id/edit",
        component: GroupEdit,
        name: "account.group.edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/account/ledger",
        component: Ledger,
        name: "account.ledger",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/ledger/create",
        component: LedgerCreate,
        name: "account.ledger.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/ledger/:id/edit",
        component: LedgerEdit,
        name: "account.ledger.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/ledger/:id/view",
        component: LedgerView,
        name: "account.ledger.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/ledger-barcode",
        component: LedgerBarcode,
        name: "account.ledger.barcode",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/account/cost-center",
        component: CostCenter,
        name: "account.cost.center",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/cost-center/create",
        component: CostCenterCreate,
        name: "account.cost.center.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/cost-center/:id/edit",
        component: EditCostCenter,
        name: "account.cost.center.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
